/** @jsx jsx */
import { Box, Container, Heading, jsx } from 'theme-ui'

const ReviewListPageHeading = ({ description, title }) => {
  return (
    <Box bg="backgroundLight" sx={{ overflow: 'hidden' }}>
      <Container pt={[3, 7, 9]} pb={[5, 6, 7]} sx={{ position: 'relative' }}>
        <img
          src="/images/backgrounds/maker-cans-line.svg"
          alt=""
          aria-hidden="true"
          loading="eager"
          sx={{
            display: [null, null, 'none'],
            height: '74px',
            left: '50%',
            mb: 2,
            position: 'relative',
            transform: 'translateX(-50%)',
            width: 'auto',
          }}
        />
        <img
          src="/images/backgrounds/maker-cans-four-1.svg"
          alt=""
          aria-hidden="true"
          sx={{
            display: ['none', null, 'block'],
            height: '300px',
            left: [null, null, '-200px', '-132px'],
            position: 'absolute',
            top: -1,
            width: 'auto',
          }}
        />
        <img
          src="/images/backgrounds/maker-cans-four-2.svg"
          alt=""
          aria-hidden="true"
          sx={{
            display: ['none', null, 'block'],
            height: '300px',
            position: 'absolute',
            right: [null, null, '-200px', '-132px'],
            top: -1,
            width: 'auto',
          }}
        />
        <Box sx={{ textAlign: 'center' }}>
          <Heading as="h1" variant="title1" mt={0} mb={[2, 3]}>
            {title}
          </Heading>
          {description && (
            <Box
              sx={{
                variant: 'text.body1',
                p: { m: 0 },
                a: {
                  variant: 'text.link',
                },
              }}
              dangerouslySetInnerHTML={{
                __html: description.childMarkdownRemark.html,
              }}
            />
          )}
        </Box>
      </Container>
    </Box>
  )
}

export default ReviewListPageHeading
